

















































// Vue
import { defineComponent, PropType } from '@vue/composition-api'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'
import { Button, Icon } from '@/components/general'

// Models
import { Paginator } from '@/models'
import { AdvanceControl } from '@/models/dailyControl'

export default defineComponent({
  name: 'AdvanceControlTableList',
  components: {
    DataTable,
    IsActive,
    Button,
    Icon
  },
  props: {
    items: {
      type: Array as PropType<AdvanceControl[]>,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object as PropType<Paginator>,
      default: () => ({
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
      })
    },
    changePage: {
      type: Function as PropType<() => void>,
      default: () => (null)
    },
    changePerPage: {
      type: Function as PropType<() => void>,
      default: () => (null)
    }
  },
  setup () {
    const fields = [
      {
        key: 'register_date',
        sortable: true,
        label: 'Fecha de Registro'
      },
      {
        key: 'discount_date',
        sortable: true,
        label: 'Fecha de Aplicación'
      },
      {
        key: 'employee.name',
        sortable: true,
        label: 'Empleado'
      },
      {
        key: 'amount',
        sortable: true,
        label: 'Importe'
      },
      {
        key: 'advanceType.name',
        sortable: true,
        label: 'Tipo de Adelanto'
      },
      {
        key: 'actions',
        sortable: false,
        label: '',
        thClass: 'one-line w-30',
        thStyle: {
          width: '10%'
        }
      }
    ]
    return {
      fields
    }
  }
})
